import { NavLink, useLocation } from "react-router-dom";
import {
  LayoutDashboard,
  FolderKanban,
  QrCode,
  CreditCard,
  User2Icon,
  Package,
  ShoppingBag,
  FileCheck,
  BarChart3,
  LogOut,
  LogOutIcon,
  FolderOpenDot,
} from "lucide-react";
import { useState } from "react";
import { useAuth } from "@/context/AuthContext";

const menuItems = [
  {
    title: "Dashboard",
    url: "/",
    icon: LayoutDashboard,
  },
  {
    title: "Projects",
    url: "/projects",
    icon: FolderKanban,
  },
  {
    title: "Brand Library",
    icon: FolderOpenDot,
    children: [
      {
        title: "Media",
        url: "/media",
      },
      {
        title: "Products",
        url: "/products",
      },
    ],
  },
  {
    title: "Qr Codes",
    url: "/qr-codes",
    icon: QrCode,
  },
  {
    title: "Analytics",
    icon: BarChart3,
    children: [
       { title: "Insights", url: "/analytics/insights" },
       { title: "Source and Medium", url: "/analytics/sourcemedium" },
      { title: "Scan Details", url: "/analytics/qr" },
      { title: "Submission Insights", url: "/my-submissions" },
      { title: "Demographics", url: "/analytics/demographic" },
      { title: "Device Analytics", url: "/analytics/device" },
    ],
  },

  // {
  //   title: "Media",
  //   url: "/media",
  //   icon: FolderKanban,
  // },
  // {
  //   title: "Products",
  //   url: "/products",
  //   icon: ShoppingBag,
  // },

  // {
  //   title: "Qr Create",
  //   url: "/qrcreate",
  //   icon: QrCode,
  // },
  // {
  //   title: "Qr Codes",
  //   url: "/qrpage",
  //   icon: QrCode,
  // },
  // {
  //   title: "Projects",
  //   url: "/projects",
  //   icon: FolderKanban,
  // },
  {
    title: "My Account",
    icon: User2Icon,
    children: [
      { title: "My Profile", url: "/my-profile" },
      { title: "Billing", url: "/billing" },
      { title: "My Subscriptions", url: "/my-subscription" },
    ],
  },
];

export const DashboardSidebar = () => {
  const location = useLocation();
  const { logout } = useAuth();

  const isActive = (path: string) => location.pathname === path;
  const [open, setOpen] = useState<string>("");

  const toggleMenu = (title: string) => {
    setOpen((prev) => (prev === title ? "" : title));
  };

  return (
    <aside className="sidebar-wrapper">
      <div
        className="sidebar sidebar-collapse"
        id="sidebar"
        style={{ display: "flex", flexDirection: "column", height: "100%" }}
      >
        <div className="sidebar__menu-group" style={{ flex: 1 }}>
          <ul className="sidebar_nav">
            <li className="menu-title">
              <span>Main Menu</span>
            </li>

            {menuItems.map((item) => {
              const Icon = item.icon;
              const hasChildren = !!item.children;
              const isOpen = open === item.title;

              return (
                <li
                  key={item.title}
                  className={`has-child ${isOpen ? "open" : ""}`}
                >
                  {hasChildren ? (
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        toggleMenu(item.title);
                      }}
                    >
                      <Icon size={18} className="nav-icon" />
                      <span className="menu-text">{item.title}</span>
                      <span className="toggle-icon"></span>
                    </a>
                  ) : (
                    <NavLink to={item.url!}>
                      <Icon size={18} className="nav-icon" />
                      <span className="menu-text">{item.title}</span>
                    </NavLink>
                  )}

                  {hasChildren && (
                    <ul className="subMenu">
                      {item.children.map((child) => (
                        <li key={child.title}>
                          <NavLink to={child.url}>{child.title}</NavLink>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              );
            })}
          </ul>
        </div>

        <div className="  ">
          <div className="sidebar__menu-group" style={{ flex: 1 }}>
            <ul className="sidebar_nav">
              <li>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    logout();
                  }}
                >
                  <LogOutIcon size={18} className="nav-icon" />
                  <span className="menu-text">Logout</span>
                </a>
              </li>
            </ul>
          </div>
          {/* <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              logout();
            }}
            className="d-flex align-items-center gap-2"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              color: "inherit",
              textDecoration: "none",
              padding: "8px 0",
            }}
          >
            <LogOut size={18} className="nav-icon" />
            <span className="menu-text">Logout</span>
          </a> */}
        </div>
      </div>
    </aside>
  );
};

// <aside className="sidebar-wrapper">
//   <div className="sidebar sidebar-collapse" id="sidebar">
//     <div className="sidebar__menu-group">
//       <ul className="sidebar_nav">
//         <li className="menu-title">
//           <span>Main menu</span>
//         </li>
//         {menuItems.map((item) => (
//           <li key={item.title}>
//             <NavLink
//               to={item.url}
//               className={isActive(item.url) ? "active" : ""}
//             >
//               <item.icon className="w-4 h-4 gap-3" />
//               <span className="menu-text ml-1">{item.title}</span>
//             </NavLink>
//           </li>
//         ))}
//       </ul>
//     </div>
//   </div>
// </aside>
